<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <div class='goods-grid'>
      <dx-data-grid ref='refPurchaseGrid'
        :data-source='rawMaterialInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="true"
        key-expr="품번"
        :focused-row-key.sync='focusedRowKey'
        @row-removed='onRowRemoved' @row-inserted='onRowInserted' @row-inserting='onRowInserting'
        @row-updated='onRowUpdated' @row-updating='onUpdating'
        @editor-preparing='onEditorPreparing' @content-ready='onContentReady'
        @init-new-row='onInitNewRow'
        @rowDblClick ='onRowDbClick'
        @context-menu-preparing="addMenuItems"
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="productType"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxEditing
          :allow-deleting="true"
          :allow-updating="true"
          :allow-adding="true"
          :use-icons="true"
          :mode='batchEdit ? "batch":"popup"'
        >
          <DxPopup
            :show-title="true"
            :width="700"
            :height="400"
            title="품록등록"
          >
            <dx-position
              my="center"
              at="center"
              of="window"
            />
          </DxPopup>
          <DxForm>
              <DxItem
              :col-count="2"
              :col-span="2"
              item-type="group"
              >
                <DxItem data-field="거래처코드"/>
                <DxItem v-if="$store.getters.getGroupName !== null" data-field="차종"/>
                <DxItem data-field="품번"/>
                <DxItem data-field="납입품번"/>
                <DxItem data-field="품명"/>
                <DxItem data-field="품목유형"/>
                <DxItem data-field="자재유형" />
                <DxItem data-field="외주가공비" />
                <DxItem data-field="재질" />
                <DxItem data-field="파레트적재량"/>
                <DxItem data-field="단위"/>
                <DxItem data-field="구매단위"/>
                <DxItem data-field="변환배율"/>
                <DxItem data-field="담당부서"/>
                <DxItem data-field="납품처코드"/>
                <!-- <DxItem data-field="납품장소"/> -->
                <DxItem data-field="사용유무"/>
              </DxItem>
            </DxForm>
        </DxEditing>
        <DxColumnFixing :enabled="true"/>
        <DxColumn
          width="90"
          :buttons="editButtons"
          type="buttons"
        />
        <DxColumn
          :allowEditing='true'
          caption="구매처"
          data-field="거래처코드"
          :fixed="true"
          :visible='true'
          edit-cell-template="companyGridTemplate"
        >
          <DxLookup
            :data-source="$store.getters.getCompanyInfo"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>

        <DxColumn
          :allowEditing='true'
          :fixed="true"
          :caption="caption고객사"
          data-field="납품처코드"
          :visible='true'
        >
           <DxLookup
            :data-source="customerLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn
          v-if="$store.getters.getGroupName !== null"
          :allowEditing='true'
          :caption="$store.getters.getGroupName"
          data-field="차종"
          :fixed="true"
          :visible='true'
        >
           <DxLookup
            :data-source="carTypeLookup"
            display-expr="모델명"
            value-expr="모델코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='isIdEdit'
          :fixed="true"
          caption="부번"
          data-field="품번"
          sort-order='asc'
          :min-width="120"
        >
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :visible='$route.query.from === "sales"'
          :allowEditing='true'
          :fixed="true"
          caption="납입부번"
          data-field="납입품번"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품명"
          data-field="품명"
          :visible='true'
          :min-width="140"
        >
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="자재유형"
          data-field="자재유형"
          :visible='true'
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="구입가"
          data-field="구입가"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn v-if="materialType !== hardWareType"
          :allowEditing="true"
          caption="판매가"
          data-field="판매가"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn v-if="materialType !== hardWareType"
          :allowEditing="isIdEdit"
          caption="외주 가공비"
          data-field="외주가공비"
          :visible='true'
          dataType="number"
          format='#,##0.00'
        >
        </DxColumn>
        <DxColumn v-if="materialType !== hardWareType"
          :allowEditing="true"
          caption="판매 가공비"
          data-field="판매가공비"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn v-if="materialType !== hardWareType"
          :allowEditing='true'
          caption="재질"
          data-field="재질"
          :visible='true'
          width="160"
        >
          <DxLookup
            :data-source="rawMeterialTypeLookup"
            display-expr="재질"
            value-expr="재질"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="적재량"
          data-field="파레트적재량"
          :visible='true'
          format='#,##0'
        >
          <dx-required-rule message="파레트 표준적재량을 입력 하세요.8"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="BOM단위"
          data-field="단위"
          :visible='true'
        >
          <dx-required-rule message="항목을 선택하세요"/>
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="주문단위"
          data-field="구매단위"
          :visible='false'
        >
          <dx-required-rule message="항목을 선택하세요"/>
          <DxLookup
            :data-source="unitLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="단위변환율"
          data-field="변환배율"
          :visible='false'
          format='#,##0.0'
          dataType="number"
        >
          <dx-required-rule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="담당부서"
          data-field="담당부서"
          :visible='true'
          edit-cell-template="treeGridTemplate"
        >
          <DxLookup
            :data-source="divisionList"
            display-expr="부서명"
            value-expr="부서코드"
          />
          <dx-required-rule message="항목을 선택하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="납품장소"
          data-field="납품장소"
          :visible='false'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="사용유무"
          data-field="사용유무"
          :visible='false'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="삭제유무"
          data-field="삭제유무"
          :visible='false'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="등록일"
          data-field="createtime"
          dataType= 'date'
          format='yyyy-MM-dd'
          width = '100'>
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          :visible='true'
          caption="수정일"
          data-field="updatetime"
          dataType= 'date'
          format='yyyy-MM-dd'
          width = '100'>
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="품번"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
        <template #companyGridTemplate="{ data: cellInfo }" >
          <CompanyGridComponent
            :value="cellInfo.value"
            :on-value-changed="cellInfo.setValue"
            @selected-company='setCompnayCode'
            :companyInfo='companyInfoList'
          />
        </template>
        <template #treeGridTemplate="{ data: cellInfo }">
          <DivisionTreeGridComponent
            :value="cellInfo.value"
            :on-value-changed="cellInfo.setValue"
            :data-source="divisionList"
          />
        </template>
      </dx-data-grid>
    </div>
    <DxPopupGen v-if='qrOptions !== null'
        :visible.sync="popupQrcode"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-title="true"
        :width="500"
        :height="590"
        :title="qrCodePopupTitle"
      >
        <SerailNoQrPrintComponent :qr-options="qrOptions"/>
    </DxPopupGen>
    <DxPopupGen v-if="popupPrice"
      :visible.sync="popupPrice"
      :drag-enabled="true"
      :close-on-outside-click="false"
      :show-title="true"
      :width="pricePopupWidth"
      :height="450"
      :title="titlePopupView"
       @hidden="onHidden"
       @showing="onShowing"
    >
      <div class="grid-wrap-popup float-left" v-show="isShowCostGrid">
        <dx-data-grid
          ref="refPurchasePriceInfoList"
          :data-source='purchasePriceInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          height='370'
          :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="false"
          key-expr="seqId"
          @row-removed='onRowRemovedPrice'
          @row-inserting='onRowInsertingPrice'
          @row-inserted='onRowInsertedPrice'
          @row-updated='onRowUpdatedPrice'
          @toolbar-preparing='onToolbarPreparingCost'
          @editor-preparing='onEditorPreparingPrice'
        >
          <DxExport
            :enabled="true"
            :file-name="titlePopupView"
          />
          <DxEditing v-if="priceEditable"
            :allow-deleting="true"
            :allow-updating="true"
            :allow-adding="true"
            :use-icons="true"
            mode='row'
          />
          <DxColumn
            :allowEditing='isEditable'
            caption="적용일자"
            data-field="적용일자"
            format='yyyy-MM-dd'
            dataType="date"
            sort-order="desc"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="구입가격"
            data-field="가격"
            format='#,##0.0'
            dataType="number"
          >
            <dx-required-rule message="항목을 입력하세요"/>
          </DxColumn>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
    </DxPopupGen>
    <DxPopupGen v-if="popupHardwarePrice"
      :visible.sync="popupHardwarePrice"
      :drag-enabled="true"
      :close-on-outside-click="false"
      :show-title="true"
      :width="500"
      :height="450"
      title="하드웨어 구입가 일괄등록"
    >
      <div>
        <dx-data-grid
          ref="refHardwarePriceInfoList"
          :data-source='hardwarePriceInfoList'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          height='370'
          :row-alternation-enabled="true"
          :focused-row-enabled="true"
          :auto-navigate-to-focused-row="false"
          key-expr="품번"
          @toolbar-preparing='onToolbarPreparingHardwarePrice'
        >
          <DxColumn
            :allowEditing='true'
            caption="품번"
            data-field="품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="구입가"
            data-field="가격"
            format='#,##0.00'
            dataType="number"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="비고"
            data-field="비고"
            width="100"
          >
          </DxColumn>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </div>
    </DxPopupGen>
     <input id="batch-detail-input" type="file" @change="onDetailFileChange($event)" accept=".xlsx" style='display: none;'>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxForm,
  DxSummary, DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup, DxPopup, DxPosition } from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import { DxItem } from 'devextreme-vue/form'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'
import CompanyGridComponent from '../../share/component/CompanyGridComponent'
import DivisionTreeGridComponent from '../../share/component/DivisionTreeGridComponent'
import axios from 'axios'
import SerailNoQrPrintComponent from '../../share/component/SerailNoQrPrintComponent'
import ExcelJS from 'exceljs'

export default {
  name: 'login',
  props: {
    materialType: null
  },
  data: function () {
    return {
      carTypeLookup: null,
      isLoading: false,
      editButtons: ['edit', 'delete',
        {
          hint: 'QR Code 보기',
          icon: 'print',
          visible: 'true',
          onClick: this.onClickPopupQrCode
        }],
      rawMaterialInfoList: null,
      gridHeight: null,
      userInfo: null,
      selectedRow: null,
      itemTypeLookup: null,
      unitLookup: null,
      selectedCompanyCode: null,
      focusedRowKey: null,
      processingTypeLookup: null,
      meterialTypeLookup: null,
      rawMeterialTypeLookup: null,
      productType: ConstDef.구매품,
      hardWareType: ConstDef.부자재,
      companyInfoList: [],
      isIdEdit: true,
      divisionList: null,
      qrCodePopupTitle: null,
      popupQrcode: false,
      qrOptions: null,
      customerLookup: null,
      batchEdit: false,
      caption고객사: null,
      // 구입가격 팝업
      popupPrice: false,
      titlePopupView: null,
      purchasePriceInfoList: null,
      priceEditable: false,
      pricePopupWidth: 780,
      isShowSalesGrid: true,
      isShowCostGrid: true,
      isEditable: true,
      // 하드웨아 구입가 일괄등록
      hardwarePriceInfoList: null,
      popupHardwarePrice: false,
      hardwareRegPriceDate: `${AppLib.getToday().substring(0, 7)}-01`
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxForm,
    DxItem,
    DxPaging,
    DxSorting,
    DxEditing,
    DxRequiredRule,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxPopup,
    DxPosition,
    DxScrolling,
    CompanyGridComponent,
    DivisionTreeGridComponent,
    DxPopupGen,
    SerailNoQrPrintComponent
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.carTypeLookup = this.$store.getters.getCarType
    // console.log(this.carTypeLookup)
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.meterialTypeLookup = this.$_.reject(this.$store.getters.getBaseDataByType(ConstDef.자재유형), function (d) { return d.코드 === ConstDef.자재유형_원자재 })
    this.rawMeterialTypeLookup = this.refreshRawMeterialLookup()
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.unitLookup = this.$store.getters.getBaseDataByType(ConstDef.단위)
    this.companyInfoList = this.$store.getters.getCompanyInfo
    this.refreshProduct(this.productType)
    this.refreshDivision()
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    addMenuItems (e) {
      if (e.target === 'content') {
        e.items = []
        if (this.selectedRow.자재유형 === ConstDef.자재유형_원자재) {
          e.items.push({
            text: '원자재(코일)가 정보',
            icon: 'find',
            onItemClick: () => {
              this.pricePopupWidth = 410
              this.refreshPurchasePrice(this.selectedRow.재질, this.selectedRow.자재유형, false)
            }
          })
        } else if (this.selectedRow.자재유형 !== ConstDef.외주품 && this.selectedRow.자재유형 !== ConstDef.외주직납품) {
          e.items.push({
            text: '구입/판매가 정보',
            icon: 'find',
            onItemClick: () => {
              this.pricePopupWidth = 410
              this.refreshPurchasePrice(this.selectedRow.품번, this.selectedRow.자재유형, false)
            }
          })
        }
        e.items.push({
          text: 'QR 코드 출력',
          icon: 'print',
          onItemClick: () => {
            this.qrCodePopupTitle = `입출고 QR 코드용 프린팅(${this.selectedRow.품번})`
            // let base64 = AesCrypto.base64Encode(e.row.data.품번)
            this.qrOptions = { title: this.selectedRow.품번, data: `${AppLib.getBase64SameLength(this.selectedRow.품번)}`, cellSize: 5 }
            this.popupQrcode = true
          }
        })
      }
    },
    onContentReady (e) {

    },
    onClickPopupQrCode (e) {
      this.qrCodePopupTitle = `입출고 QR 코드용 프린팅(${e.row.data.품번})`
      // let base64 = AesCrypto.base64Encode(e.row.data.품번)
      this.qrOptions = null
      this.qrOptions = { title: e.row.data.품번, data: `${AppLib.getBase64SameLength(e.row.data.품번)}`, cellSize: 5 }
      this.popupQrcode = true
    },
    onQrUpdated (e) {
      // // // console.log(e)
      // // // console.log(e.width)
      this.$Q('.qr-code-wrap').css('width', e.width + 'px')
    },
    onEditorPreparing (e) {
      if (e.dataField === '품번' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    onInitNewRow (row) {
      // // // console.log(row)
      row.data.사용유무 = true
      row.data.삭제유무 = false
      row.data.품목유형 = this.productType // 구매품
    },
    onRowDbClickPressCost (row) {
      if (row.data.자재유형 === ConstDef.외주품 || row.data.자재유형 === ConstDef.외주직납품) {
        const url = `/main/scrapCost?품번=${row.data.품번}&품명=${row.data.품명}&품목유형=${ConstDef.다공정품}`
        window.open(url, '_blank')
      }
    },
    onRowDbClick (row) {
      if (row.data.자재유형 === ConstDef.자재유형_원자재) {
        this.pricePopupWidth = 410
        this.refreshPurchasePrice(row.data.재질, row.data.자재유형, false)
      } else if (row.data.자재유형 !== ConstDef.외주품 && row.data.자재유형 !== ConstDef.외주직납품) {
        this.pricePopupWidth = 410
        this.refreshPurchasePrice(row.data.품번, row.data.자재유형, false)
      }
    },
    onRowInserted (row) {
      // console.log(row)
      row.data.updatetime = row.data.createtime = AppLib.getToday()
      row.data.updateid = row.data.createid = this.userInfo.userName

      if (row.data.납입품번 === undefined) {
        row.data.납입품번 = row.data.품번
      }
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))

      if (row.data.품목유형 === ConstDef.구매품) {
        row.data.공정유형 = null
        row.data.표준공수 = null
      }
      if (row.data.자재유형 !== ConstDef.외주품 && row.data.자재유형 !== ConstDef.외주직납품) {
        row.data.외주가공비 = null
      }

      const goods = this.$_sp.runInsertSqlProc('품목정보', ['거래처명'], array)
      let param = {
        이월일자: `${row.data.createtime.substring(0, 7)}-01`,
        품번: row.data.품번,
        재고: 0,
        createid: this.userInfo.userName
      }
      const stock = this.$_sp.runUpdateProc('spSaveCurrentStock', [param])
      // console.log(row)
      axios.all([goods, stock])
        .then(axios.spread((...reponse) => {
          this.focusedRowKey = row.data.품번
          this.$snotify.info('저장 되었습니다.')
          if (row.data.자재유형 === ConstDef.외주품 || row.data.자재유형 === ConstDef.외주직납품) {
            const url = `/main/scrapCost?품번=${row.data.품번}&품명=${row.data.품명}&품목유형=${ConstDef.다공정품}`
            // console.log(url)
            window.open(url, '_blank')
          } else {
            let key = row.data.품번
            if (row.data.자재유형 === ConstDef.자재유형_원자재) key = row.data.재질
            this.refreshPurchasePrice(key, row.data.자재유형, true)
          }
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowInserting (row) {
      // console.log(row)
      if (this.$_.findIndex(this.rawMaterialInfoList, { 품번: row.data.품번 }) >= 0) {
        this.$snotify.info('품번이 중복되었습니다.')
        row.cancel = true
      } else {
        if (row.data.자재유형 === ConstDef.외주품 || row.data.자재유형 === ConstDef.외주직납품 || row.data.자재유형 === ConstDef.자재유형_원자재) {
          if (row.data.재질 === undefined) {
            this.$snotify.info('재질을 선택하여 주세요')
            row.cancel = true
          }
          if (row.data.자재유형 !== ConstDef.자재유형_원자재) {
            if (row.data.외주가공비 === undefined) {
              this.$snotify.info('외주 가공원가를 입력하여 주세요')
              row.cancel = true
            }
            if (row.data.자재유형 === ConstDef.외주직납품 && row.data.납품처코드 === undefined) {
              this.$snotify.info('납품사를 선택하여 주세요')
              row.cancel = true
            }
            if (row.data.자재유형 === ConstDef.외주직납품 && row.data.차종 === undefined) {
              this.$snotify.info('차종을 선택하여 주세요.')
              row.cancel = true
            }
          }
        }
      }
    },
    async onRowRemoved (row) {
      this.isLoading = true
      await this.$_sp.runNoEncodeFindSqlProc('BOM차종', { 품번: row.data.품번 })
        .then(data => {
          if (this.$_sp.MakeModel(data).length > 0) {
            this.$snotify.error('양산 차종에 등록된 완제품 입니다')
            this.rawMaterialInfoList.push(row.data)
            this.$refs.refPurchaseGrid.instance.refresh()
            this.focusedRowKey = row.data.품번
            this.isLoading = false
          }
        })
      if (this.isLoading === false) return
      await this.$_sp.runNoEncodeFindSqlProc('BOM정전개', { 품번: row.data.품번 })
        .then(data => {
          if (this.$_sp.MakeModel(data).length > 0) {
            this.$snotify.error('BOM 구성이 되어있는 제품 입니다.')
            this.rawMaterialInfoList.push(row.data)
            this.$refs.refPurchaseGrid.instance.refresh()
            this.focusedRowKey = row.data.품번
            this.isLoading = false
          }
        })
      if (this.isLoading === false) return
      this.$_sp.runUpdateProc('spDeleteGoodsInfo', [{ 품번: row.data.품번 }])
        .then(data => {
          this.isLoading = false
          this.$snotify.info('삭제되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onUpdating (row) {
      // // console.log(row)
      if (row.newData.거래처명 === undefined) {
        this.selectedCompanyCode = row.oldData.거래처코드
      }
      if (row.newData.자재유형 !== undefined && (row.newData.자재유형 === ConstDef.외주품 || row.data.자재유형 === ConstDef.외주직납품)) {
        if (row.newData.외주가공비 === undefined) {
          this.$snotify.info('외주 가공원가를 입력하여 주세요')
          row.cancel = true
        }
      }
    },
    onRowUpdated (row) {
      // console.log(row.data)
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userId
      if (row.data.자재유형 !== ConstDef.외주품 && row.data.자재유형 !== ConstDef.외주직납품) {
        row.data.외주가공비 = null
      }

      if (row.data.납입품번 === null || row.data.납입품번.length === 0) {
        row.data.납입품번 = row.data.품번
      }
      row.data.공정유형 = null
      row.data.표준공수 = null

      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      // console.log(array)
      this.$_sp.runUpdateSqlProc('품목정보', ['품번'], ['거래처명', '판매가', '구입가'], array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxCheckBox',
          options: {
            value: this.batchEdit,
            text: '일괄수정',
            onValueChanged: (args) => {
              this.batchEdit = args.value
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '구입가 일괄등록',
            icon: 'save',
            text: '구입가 일괄등록',
            type: 'default',
            visible: this.materialType === ConstDef.부자재,
            focusStateEnabled: true,
            onClick: (args) => {
              this.hardwarePriceInfoList = []
              this.popupHardwarePrice = true
            }
          }
        }
      )
    },
    refreshDivision () {
      this.$_sp.runNoEncodeFindSqlProc('부서정보', null)
        .then((data) => {
          this.divisionList = this.$_sp.MakeModel(data)
        })
    },
    refreshProduct (type) {
      this.productType = type
      this.isLoading = true
      this.customerLookup = this.$store.getters.getCompanyInfo
      this.$_sp.runNoEncodeFindProc('spFindAllPurchaseWithPrice', {})
        .then((data) => {
          // console.log(this.$_sp.MakeModel(data))
          if (this.materialType === ConstDef.부자재) {
            this.rawMaterialInfoList = this.$_sp.MakeModel(data).filter(item => (item.자재유형 === ConstDef.부자재 || item.자재유형 === ConstDef.사급품 || item.자재유형 === ConstDef.소모품))
            this.caption고객사 = '마감처'
          } else {
            this.rawMaterialInfoList = this.$_sp.MakeModel(data).filter(item => item.자재유형 === ConstDef.외주품 || item.자재유형 === ConstDef.외주직납품)
            this.caption고객사 = '고객사'
          }
          this.gridHeight = (screen.height - 250) * 0.95
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshRawMeterialLookup () {
      this.$_sp.runNoEncodeFindProc('spFindAllRawMeterialLookup', {})
        .then((data) => {
          this.rawMeterialTypeLookup = this.$_sp.MakeModel(data)
          // // console.log(this.rawMeterialTypeLookup)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // emit compnay search
    setCompnayCode (code) {
      // console.log(code)
      this.selectedCompanyCode = code
    },
    // company info
    allowEditIcon (e) {
      // console.log(e)
      return e.row.data.적용일자 >= (AppLib.nowTimestamp() - 24 * 3600 * 1000)
    },
    refreshCompany () {
      this.$_sp.runNoEncodeFindSqlProc('거래처정보', null)
        .then((data) => {
          this.companyInfoList = this.$_sp.MakeModel(data)
        })
    },
    onHidden () {
      this.popupPrice = false
    },
    onShowing (e) {
      // console.log(e)
      if (this.selectedRow === null) return true
      switch (this.selectedRow.자재유형) {
        case ConstDef.부자재:
        case ConstDef.소모품:
        case ConstDef.사급품:
          this.isShowSalesGrid = true
          this.isShowCostGrid = true
          break
        case ConstDef.자재유형_원자재:
          this.isShowSalesGrid = false
          this.isShowCostGrid = true
          break
        case ConstDef.외주직납품:
        case ConstDef.외주품:
          this.isShowSalesGrid = true
          this.isShowCostGrid = false
          break
      }
      // console.log(this.isShowCostGrid, this.isShowSalesGrid)
    },
    onEditorPreparingPrice (e) {
      if (e.dataField === '가격' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isEditable = true
        } else {
          this.isEditable = false
        }
      }
    },
    // 구입가/판매가 팝업
    onRowInsertingPrice (row) {
      const day = AppLib.formatDateFromTimeStamp(row.data.적용일자)
      if (day.substring(8, 10) !== '01') {
        this.$snotify.info('적용일자는 매월 1일만 가능합니다.')
        row.cancel = true
      }
      if (this.purchasePriceInfoList.length > 0) {
        const max = this.$_.max(this.purchasePriceInfoList, function (item) {
          return item.적용일자
        })
        // console.log(max.적용일자)
        if (row.data.적용일자 <= max.적용일자) {
          this.$snotify.info(`적용일자는 ${AppLib.formatDateFromTimeStamp(max.적용일자)} 보다 커야 합니다.`)
          row.cancel = true
        }
      }
    },
    onRowInsertedPrice (row) {
      const table = '가격정보_HW_사급_구입가'
      if (row.data.적용일자 !== null && (typeof row.data.적용일자) === 'object') {
        row.data.적용일자 = row.data.적용일자.getTime()
      }
      row.data.품번 = this.selectedRow.품번
      this.$_sp.runInsertAndFindSqlProc(table, ['적용일자', '품번'], ['seqId'], row.data)
        .then((data) => {
          // console.log(this.$_sp.MakeModel(data))
          row.data.seqId = this.$_sp.MakeModel(data)[0].seqId
          this.$refs.refPurchasePriceInfoList.instance.refresh()
          this.$snotify.info('저장 되었습니다.')
          this.updateAllPriceLastDate()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowRemovedPrice (row) {
      const delSp = this.$_sp.runDeleteSqlProc('가격정보_HW_사급_구입가', [{ seqId: row.data.seqId }])
      const upSp = this.$_sp.runUpdateSqlProc('가격정보_HW_사급_구입가', ['품번'], null, [{ 품번: row.data.품번, 만료일자: null }])
      axios.all([upSp, delSp])
        .then(axios.spread((...reponse) => {
          this.$snotify.info('삭제 되었습니다.')
          this.updateAllPriceLastDate()
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdatedPrice (row) {
      this.$_sp.runUpdateSqlProc('가격정보_HW_사급_구입가', ['seqId'], null, [row.data])
        .then((data) => {
          this.$snotify('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onToolbarPreparingCost (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:blue;'><b>구입가정보</b></div>`
          }
        }
      )
    },
    refreshPurchasePrice (goodsNo, type, isSalePrice) {
      // console.log(type)
      this.titlePopupView = `${goodsNo} 가격정보`
      let table = null
      let param = null
      if (type === ConstDef.자재유형_원자재) {
        table = '스크랩코일가격'
        param = { 재질: goodsNo }
        this.priceEditable = false
      } else if (isSalePrice === false && (type === ConstDef.외주품 || type === ConstDef.외주직납품)) {
        table = '가격정보_외주품_구입가'
        param = { 품번: goodsNo }
        this.priceEditable = false
      } else {
        table = '가격정보_HW_사급_구입가'
        param = { 품번: goodsNo }
        this.priceEditable = true
      }
      const spCost = this.$_sp.runNoEncodeFindSqlProc(table, param)
      axios.all([spCost])
        .then(axios.spread((...reponse) => {
          this.purchasePriceInfoList = this.$_sp.MakeModel(reponse[0])
          this.popupPrice = true
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    updateAllPriceLastDate () {
      this.$_sp.runUpdateProc('spUpdateAllPriceLastDate', [{ null: '' }])
        .then((data) => {
        })
    },
    onToolbarPreparingSales (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:blue;'><b>판매가정보</b></div>`
          }
        }
      )
    },
    // 하으웨어 구입가 일괄등록
    onDetailFileChange: function ($event) {
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      let file = document.getElementById('batch-detail-input')['files'][0]
      this.$Q('#batch-detail-input').val('')
      let reader = new FileReader()
      const vm = this
      reader.onloadend = function (event) {
        console.log('reader.onloadend')
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(function (workbook) {
          let worksheet = workbook.worksheets[0]
          console.log(worksheet)
          let row = null
          for (let i = 2; i < 1000; i++) {
            let temp = {}
            row = worksheet.getRow(i)
            temp.품번 = AppLib.getCellFromExcel(row, 1)
            if (temp.품번 === null) {
              console.log(`read row=${i - 1}`)
              break
            }
            temp.가격 = AppLib.getCellFromExcel(row, 2)
            temp.적용일자 = null
            console.log(temp)
            vm.hardwarePriceInfoList.push(temp)
          }
          console.log(vm.hardwarePriceInfoList)
        })
      }
      reader.readAsArrayBuffer(file)
    },
    onToolbarPreparingHardwarePrice (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:blue;'><b>적용월 : </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 80,
            value: this.hardwareRegPriceDate,
            type: 'date',
            calendarOptions: {
              maxZoomLevel: 'year',
              minZoomLevel: 'century'
            },
            displayFormat: 'yyyy-MM',
            onValueChanged: (args) => {
              this.hardwareRegPriceDate = args.value
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '구입가 파일선택',
            icon: 'exportxlsx',
            text: '엑셀파일선택',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$Q('#batch-detail-input').click()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '구입가 일괄저장',
            icon: 'save',
            text: '일괄저장',
            type: 'success',
            focusStateEnabled: true,
            onClick: (args) => {
              console.log(this.hardwarePriceInfoList)
              if (this.hardwarePriceInfoList.length === 0) {
                this.$snotify.error('등록할 구입가격이 없습니다.')
                return
              }
              this.$snotify.confirm(`${this.hardwareRegPriceDate}기준일로 구임가를 등록 하시겠습니까?`, '', {
                timeout: 10000,
                showProgressBar: true,
                closeOnClick: false,
                pauseOnHover: true,
                buttons: [
                  { text: '등록',
                    action: (toast) => {
                      this.$snotify.remove(toast.id)
                      this.saveHardwarePrice(this.hardwarePriceInfoList)
                    }
                  },
                  { text: '취소',
                    action: (toast) => { this.$snotify.remove(toast.id) }
                  }
                ]
              })
            }
          }
        }
      )
    },
    saveHardwarePrice (list) {
      this.isLoading = true

      list.forEach(item => {
        item.적용일자 = this.hardwareRegPriceDate
      })

      this.$_sp.runInsertOrUpdayeSqlProc('가격정보_HW_사급_구입가', ['적용일자', '품번'], null, list)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
          this.updateAllPriceLastDate()
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.grid-wrap-popup {
  width: 352px;
  padding: 0 10px 0 10px
}
</style>
